import React from "react";
import { Link, useParams } from "react-router-dom";
import Card from "../components/Card";
import Seo from "../components/Seo";
import ProjectPreview from "../components/qa/ProjectPreview";
import { assets, getResumeUrl } from "../content/assets";
import { getCopy } from "../content/portfolio";
import { projectKeys } from "../content/qaProjects";

export default function QaHome() {
  const { locale = "de" } = useParams();
  const copy = getCopy(locale);
  const prefix = `/${locale}`;
  const schema = [{ "@context": "https://schema.org", "@type": "ProfilePage", mainEntity: { "@type": "Person", name: "Anton Rost", jobTitle: "QA Engineer", url: `https://antonrost.de${prefix}/`, image: assets.heroPortrait.large, knowsAbout: copy.home.capabilities.map(item => item[0]) } }, { "@context": "https://schema.org", "@type": "WebSite", name: "Anton Rost QA Engineering Portfolio", url: `https://antonrost.de${prefix}/`, inLanguage: locale }];
  return (
    <div className="page-wrapper">
      <Seo locale={locale} metadata={copy.home.seo} path="/" schema={schema} image={assets.heroPortrait.large} imageAlt={locale === "de" ? "Porträt von Anton Rost" : "Portrait of Anton Rost"} />
      <section className="content-wrapper qa-hero" aria-labelledby="portfolio-title">
        <div className="landing-wrapper qa-landing-wrapper">
          <div className="imagery-landing">
            <img
              className="image"
              src={assets.heroPortrait.medium}
              srcSet={`${assets.heroPortrait.small} 480w, ${assets.heroPortrait.medium} 800w, ${assets.heroPortrait.large} 1200w`}
              sizes="(max-width: 768px) calc(100vw - 2.25rem), min(50vw, 600px)"
              alt={locale === "de" ? "Porträt von Anton Rost" : "Portrait of Anton Rost"}
              width="1200"
              height="1600"
              fetchpriority="high"
              decoding="async"
            />
          </div>
          <div className="content-header-landing qa-landing-copy">
            <p className="bodycopy">{copy.home.eyebrow}</p>
            <h1 id="portfolio-title" className="h1">{copy.home.title}</h1>
            <div className="qa-landing-rule" aria-hidden="true" />
            <p className="bodycopy">{copy.home.intro}</p>
            {copy.home.availability && <p className="bodycopy qa-availability">{copy.home.availability}</p>}
            <div className="qa-cta-row"><Link className="button-primary bodycopy" to={`${prefix}/projects/`}>{copy.home.primary}</Link><a className="button-secondary bodycopy" href={getResumeUrl(locale)} target="_blank" rel="noreferrer">{copy.home.secondary}<span className="visually-hidden"> {locale === "de" ? "öffnet in einem neuen Tab" : "opens in a new tab"}</span></a></div>
          </div>
        </div>
      </section>
      <section id="capabilities" className="content-wrapper">
        <div className="content-header"><h2 className="h2">{copy.home.capabilitiesTitle}</h2><p className="h3">{copy.home.capabilitiesSubhead}</p></div>
        <div className="card-wrapper">{copy.home.capabilities.map(([title, description]) => <Card key={title} title={title} description={description} icon="" />)}</div>
        <Link className="button-secondary bodycopy qa-section-link" to={`${prefix}/capabilities/`}>{copy.nav.capabilities}</Link>
      </section>
      <section id="projects" className="content-wrapper">
        <div className="content-header"><h2 className="h2">{copy.home.projectsTitle}</h2><p className="h3">{copy.home.projectsSubhead}</p></div>
        <div className="qa-project-grid">{projectKeys.map(key => <ProjectPreview key={key} locale={locale} projectKey={key} headingLevel="h3" />)}</div>
        <Link className="button-secondary bodycopy qa-section-link" to={`${prefix}/projects/`}>{copy.common.allProjects}</Link>
      </section>
      <section className="content-wrapper">
        <div className="content-header"><h2 className="h2">{copy.home.approachTitle}</h2></div>
        <div className="card-wrapper">{copy.home.approach.map(([title, description]) => <Card key={title} title={title} description={description} icon="" />)}</div>
      </section>
    </div>
  );
}
